export const activeOnSiteEvent = 'Active on Site';
export const cartViewedEvent = 'Cart Viewed';
export const categorySelectedEvent = 'Category Selected';
export const checkoutStartedEvent = 'Checkout Started';
export const departmentSelectedEvent = 'Department Selected';
export const designersViewedEvent = 'Designers Viewed';
export const emailSubmittedEvent = 'Email Submitted';
export const filterAppliedEvent = 'Filter Applied';
export const freshchatStartedEvent = 'Freshchat Started';
export const homeBoxSelectedEvent = 'Homepage Box Selected';
export const homepageViewedEvent = 'Homepage Viewed';
export const movedToCartEvent = 'Moved to Cart';
export const movedToWishlistEvent = 'Moved to Wishlist';
export const newsletterSubscribeSelectedEvent = 'Newsletter Subscribe Selected';
export const newsletterSubscribeSubmittedEvent = 'Newsletter Subscribe Submitted';
export const passwordSubmittedEvent = 'Password Submitted';
export const productAddedEvent = 'Product Added';
export const klaviyoAddedEvent = 'Klaviyo Product Added';
export const productCountChangedEvent = 'Product Count Changed';
export const productDetailsViewedEvent = 'Product Details Viewed';
export const productNoImagesEvent = 'Product No Images';
export const productOutOfStockEvent = 'Product Out of Stock';
export const productRemovedEvent = 'Product Removed';
export const productsSearchedEvent = 'Products Searched';
export const productsViewedEvent = 'Products Viewed';
export const productUnavailableEvent = 'Product Unavailable';
export const resultsPageChangedEvent = 'Results Page Changed';
export const signinErrorViewedEvent = 'Signin Error Viewed';
export const signupErrorViewedEvent = 'Signup Error Viewed';
export const sizeGuideTabSelectedEvent = 'Size Guide Tab Selected';
export const sizeGuideViewedEvent = 'Size Guide Viewed';
export const sizeListViewedEvent = 'Size List Viewed';
export const trackPeopleEvent = '';
export const userSignsInEvent = 'User Signs In';
export const userSignsOutEvent = 'User Signs Out';
export const userSignsUpEvent = 'User Signs Up';
